/**
 * 需求管理列表状态
 * @param str
 * @returns {string}
 */
/* 状态*/
export const quoteStateFilter = (value) => {
 var map = ['', '待报价', '待确认报价', '已确认报价'];
 return map[+value] || '-';
}
/* 状态*/
export const stateFilter = (value) => {
 let map = ['待审核','审核中','审核通过','审核不通过','已取消']
 return map[+value] || '-'
}

/* 项目阶段*/
export const stageFilter = (status) => {
  var statusMap = {
        1: "方案设计",
        2: "施工图",
        3: "深化设计",
        4: "初步设计",
  };
  return statusMap[status];
}

/* 交付产品*/
export const putType = (status) => {
  var statusMap = {
        1: "方案",
        2: "报价清单",
        3: "图纸",
        4: "标书",
  };
  return statusMap[status];
}
/* 交付产品*/
export const typeFilter = (type) => {
  console.log(type,'type111111');
  if (type) {
      var typeArr = type.split(",");
      for (var i = 0; i < typeArr.length; i++) {
          if (typeArr[i] === "1") {
              typeArr[i] = "方案";
          }
          if (typeArr[i] === "2") {
              typeArr[i] = "报价清单";
          }
          if (typeArr[i] === "3") {
              typeArr[i] = "图纸";
          }
          if (typeArr[i] === "4") {
              typeArr[i] = "标书";
          }
      }
      return typeArr.join("，");
  }
}

/* 项目阶段*/
export const newStatus = (value) => {
 if (value) {
     if (value === -1) {
         return '设计中';
     }
     var map = {
         1: '待接单',
         2: '设计中',
         3: '设计中',
         4: '待验收',
         5: '已完成',
         6: '已拒绝',
         7: '待评价',
         20: '待支付',
         30: '待派单',
         50: '已取消',
     };
     return map[value] || '-';
 }
}

/* 项目阶段*/
export const statusList = (status) => {
  var statusMap = {
        0: "待报价",
        1: "已报价",
        2: "已拒绝",
        3: "已过期",
  };
  return statusMap[status];
}
export const typeFilters = (type) => {
  var statusMap = {
        1: "方案",
        2: "报价清单",
        3: "图纸",
        4: "标书",
  };
  return statusMap[type];
}
export const startStatus = (type) => {
  //任务状态 1-待接单；2-设计中；3-待审核；4-待验收；5-已完成；6-已拒绝；-1-审核不通过,不传-全部
  var statusMap = {
        1: "待接单",
        2: "设计中",
        3: "待审核",
        4: "待验收",
        5: "已完成",
        6: "已拒绝",
        7: "已完成",
  };
  return statusMap[type];
}


// WEBPACK FOOTER //
// ./src/filters/status.js